export default "__VITE_ASSET__e1ab5a99__"